import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { handleValidNumber } from "src/utils/regularExpression";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import { IoClose } from "react-icons/io5";
import { RetaierRewardFormValues } from "../Add/AddRetailerRewardWrapper";
import { useGetAddPaymentOtpMutation } from "src/services/DistributorServices";
import { useEffect, useState } from "react";
import { showToast } from "src/utils/toaster/showToast";
import { useParams } from "react-router-dom";

type Props = {
  formikProps: FormikProps<RetaierRewardFormValues>;
  onClose: () => void;
  formType: "Add" | "Edit";
  wantToDisabledFiled: boolean;
  setWantToDisabledFiled: any;
};

const applicationTypeOptions = [
  {
    label: "PAN",
    value: "PAN",
  },
  {
    label: "ITR",
    value: "ITR",
  },
  {
    label: "GUMASTA",
    value: "GUMASTA",
  },
  {
    label: "DSC",
    value: "DSC",
  },
  {
    label: "MSME",
    value: "MSME",
  },
];

const transactionTypeOptions = [
  {
    label: "CREDIT",
    value: "CREDIT",
  },
  {
    label: "DEBIT",
    value: "DEBIT",
  },
];

const RetaierRewardForm = ({
  formikProps,
  onClose,
  formType,
  wantToDisabledFiled,
  setWantToDisabledFiled,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const [getOtp, getOtpInfo] = useGetAddPaymentOtpMutation();
  const [counter, setCounter] = useState(0);
  const [isEnableOtpField, setIsEnableOtpField] = useState(false);
  const { retailerId } = useParams();

  useEffect(() => {
    const timer =
      counter > 0 ? setInterval(() => setCounter(counter - 1), 1000) : 0;
    return () => clearInterval(timer);
  }, [counter]);

  const handleGetOtp = () => {
    getOtp({
      userId: retailerId,
      type: formType === "Add" ? "ADD" : "EDIT",
      walletType: "REWARD",
      transactionType: values?.transactionType,
      amount: values?.rewardPoints,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          setIsEnableOtpField(true);
          setWantToDisabledFiled(true);
          setCounter(59);
        } else {
          showToast("error", res?.data?.message);
        }
      }
    });
  };
  return (
    <div className="flex p-4 flex-col gap-6 relative">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "Add" ? "Add Reward" : "Update Reward"}
        </div>

        <button
          type="button"
          onClick={onClose}
          className="p-2 rounded-full flex justify-center items-center bg-slate-200 hover:bg-red-400 hover:text-white transition-all"
        >
          <IoClose />
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Amount */}
        <div>
          <ATMTextField
          disabled={wantToDisabledFiled}
            name="rewardPoints"
            value={values?.rewardPoints}
            onChange={(e) =>
              handleValidNumber(e) &&
              setFieldValue("rewardPoints", e.target.value)
            }
            label="Point"
            placeholder="Enter Points"
            onBlur={handleBlur}
          />
        </div>
        {/* Appplication Type */}
        <div>
          <ATMSelect
          disabled={wantToDisabledFiled}
            name="applicationType"
            value={values?.applicationType || ""}
            onChange={(e) => {
              setFieldValue("applicationType", e.target.value);
            }}
            label="Appplication Type"
            options={applicationTypeOptions}
          />
        </div>
        {/* Appplication Type */}
        <div>
          <ATMSelect
          disabled={wantToDisabledFiled}
            name="transactionType"
            value={values?.transactionType || ""}
            onChange={(e) => {
              setFieldValue("transactionType", e.target.value);
            }}
            label="Transcation Type"
            options={transactionTypeOptions}
          />
        </div>

        {/* Remark */}
        <div className="">
          <ATMTextArea
          disabled={wantToDisabledFiled}
            minRows={3}
            name="remark"
            value={values?.remark}
            onChange={(newValue) => setFieldValue("remark", newValue)}
            label="Remark"
            placeholder="Enter Remark"
          />
        </div>
        {/* OTP */}
        <div>
          <ATMTextField
            disabled={!isEnableOtpField}
            name="otp"
            required
            value={values?.otp}
            onChange={(e) =>
              handleValidNumber(e) && setFieldValue("otp", e.target.value)
            }
            label="OTP"
            placeholder="Enter Otp"
            onBlur={handleBlur}
          />
        </div>
        <div className="flex justify-end text-center  text-[16px] font-medium items-start">
          {counter <= 0 ? (
            <div>
              {/* <p> Didn &#x0315; t get the OTP</p> */}
              <div className="flex justify-center ">
                <ATMLoadingButton
                  isLoading={getOtpInfo?.isLoading}
                  className="h-[36px] bg-blue-700"
                  onClick={() => {
                    handleGetOtp();
                  }}
                >
                  Send OTP
                </ATMLoadingButton>
              </div>
            </div>
          ) : (
            <div className="flex gap-2">
              <p> Otp Resend in</p>
              <p className="text-link">
                00:
                {counter?.toString()?.length < 2 ? "0" + counter : counter}
              </p>
            </div>
          )}
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default RetaierRewardForm;
